// import React, { useEffect, useState, useRef } from "react";
// import { Link } from "react-router-dom";
// import { FaPlus } from "react-icons/fa";
// import { Modal, Button, Form, Table, Pagination, Container, Row, Col } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FaEye, FaEdit } from "react-icons/fa";
// import { RiDeleteBin3Fill } from "react-icons/ri";
// import { Dropdown } from 'react-bootstrap';
// import { BsThreeDots } from "react-icons/bs";
// import { MdAirplanemodeInactive, MdAirplanemodeActive, MdOutlineUpcoming, MdUpcoming } from "react-icons/md";

// const API_URL = process.env.REACT_APP_API_URL;
// const imageAPIURL = process.env.REACT_APP_Image_URL;

// function ActiveBlockList() {
//   const [blocks, setBlocks] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [showEditModal, setShowEdit] = useState(false);
//   const [selectedBlock, setSelectedBlock] = useState(null);
//   const [selectedimagePath, setSelectedimagePath] = useState(null);
//   const [editFormData, setEditFormData] = useState({
//     id: "",
//     name: "",
//     status: "active",
//     image: null,
//   });
//   const imageInputRef = useRef(null);


//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//   });


//   const showCustomMessageModal = (title, text, type, confirmAction = null) => {
//     setMessageModalContent({ title, text, type, confirmAction });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//     setMessageModalContent({ title: "", text: "", type: "", confirmAction: null });
//   };


//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };


//   const fetchBlocks = async (page = 1) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//         throw new Error("Authentication token not found. Please log in.");
//       }


//       const response = await fetch(
//         `${API_URL}/block-list-active?page=${page}&limit=10`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (!response.ok) {
//         if (response.status === 401) {
//           showCustomMessageModal("Authorization Error", "Unauthorized: Please log in again.", "error");
//           throw new Error("Unauthorized: Please log in again.");
//         }
//         const errorData = await response.json();
//         showCustomMessageModal("Error", errorData.message || "Failed to fetch blocks.", "error");
//         throw new Error(errorData.message || "Failed to fetch blocks.");
//       }

//       const data = await response.json();

//       setBlocks(data.data || []);
//       setSelectedimagePath(data.imagePath);
//       setTotalPages(data.data.totalPages || 1);
//       setCurrentPage(page);
//     } catch (err) {
//       console.error("Fetch blocks error:", err);

//     } finally {
//       setLoading(false);
//     }
//   };


//   useEffect(() => {
//     fetchBlocks(currentPage);
//   }, [currentPage]);


//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };


//   const handleViewBlock = async (blockId) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//         throw new Error("Authentication token not found. Please log in.");
//       }

//       const response = await fetch(`${API_URL}/block-view`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id: blockId }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         showCustomMessageModal("Error", errorData.message || "Failed to fetch block details.", "error");
//         throw new Error(errorData.message || "Failed to fetch block details.");
//       }

//       const data = await response.json();
//       setSelectedBlock(data.data);
//       setShowViewModal(true);
//     } catch (err) {
//       console.error("View block error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };


//   const handleEditBlock = async (blockId) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//         throw new Error("Authentication token not found. Please log in.");
//       }

//       const response = await fetch(`${API_URL}/block-edit`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id: blockId }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         showCustomMessageModal("Error", errorData.message || "Failed to fetch block for editing.", "error");
//         throw new Error(errorData.message || "Failed to fetch block for editing.");
//       }

//       const data = await response.json();
//       const blockData = data.data;
//       setSelectedBlock(blockData);
//       setEditFormData({
//         id: blockData.id,
//         name: blockData.name || "",
//         status: blockData.status || "active",
//         image: null,
//       });
//       setShowEdit(true);
//     } catch (err) {
//       console.error("Edit block error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };


//   const handleEditFormChange = (e) => {
//     const { name, value, files } = e.target;
//     if (name === "image") {
//       setEditFormData((prevData) => ({
//         ...prevData,
//         image: files[0],
//       }));
//     } else {
//       setEditFormData((prevData) => ({
//         ...prevData,
//         [name]: value,
//       }));
//     }
//   };


//   const handleUpdateBlock = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError(null);

//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//         throw new Error("Authentication token not found. Please log in.");
//       }

//       const formDataToSend = new FormData();
//       formDataToSend.append("project_id", editFormData.id);
//       formDataToSend.append("name", editFormData.name);
//       formDataToSend.append("status", editFormData.status);
//       if (editFormData.image) {
//         formDataToSend.append("image", editFormData.image);
//       }

//       const response = await fetch(`${API_URL}/block-update`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,

//         },
//         body: formDataToSend,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         showCustomMessageModal("Error", errorData.message || "Failed to update block.", "error");
//         throw new Error(errorData.message || "Failed to update block.");
//       }

//       showCustomMessageModal("Success", "Block updated successfully!", "success");
//       setShowEdit(false);
//       fetchBlocks(currentPage);
//     } catch (err) {
//       console.error("Update block error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };


//   const handleStatusUpdate = async (blockId, currentStatus) => {
//     const newStatus = currentStatus === "active" ? "inactive" : "active";
//     showCustomMessageModal(
//       "Confirm Status Change",
//       `Do you want to change the status to ${newStatus}?`,
//       "warning",
//       async () => {
//         setLoading(true);
//         setError(null);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//             throw new Error("Authentication token not found. Please log in.");
//           }

//           const response = await fetch(`${API_URL}/block-status-update`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({
//               id: blockId,
//               status: newStatus,
//             }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             showCustomMessageModal("Error", errorData.message || "Failed to update block status.", "error");
//             throw new Error(errorData.message || "Failed to update block status.");
//           }
//           const result = await response.json();
//           if (result.success == "1") {
//             showCustomMessageModal("Success", "Block status updated successfully!", "success");
//             fetchBlocks(currentPage);
//           }
//           else {
//             showCustomMessageModal("Error", result.message || "Somthing Went Wrong!", "success");
//           }

//           // showCustomMessageModal("Success", "Block status updated successfully!", "success");
//           // fetchBlocks(currentPage);
//         } catch (err) {
//           console.error("Status update error:", err);
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };


//   const handleDeleteBlock = async (blockId) => {
//     showCustomMessageModal(
//       "Confirm Deletion",
//       "Are you sure you want to delete this block? This action cannot be undone.",
//       "warning",
//       async () => {
//         setLoading(true);
//         setError(null);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//             throw new Error("Authentication token not found. Please log in.");
//           }

//           const response = await fetch(`${API_URL}/block-delete`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ id: blockId }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             showCustomMessageModal("Error", errorData.message || "Failed to delete block.", "error");
//             throw new Error(errorData.message || "Failed to delete block.");
//           }

//           showCustomMessageModal("Success", "Block deleted successfully!", "success");
//           fetchBlocks(currentPage);
//         } catch (err) {
//           console.error("Delete block error:", err);
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };


//   const handleCloseViewModal = () => {
//     setShowViewModal(false);
//     setSelectedBlock(null);
//   };

//   const handleCloseEditModal = () => {
//     setShowEdit(false);
//     setSelectedBlock(null);
//     setEditFormData({
//       id: "",
//       name: "",
//       status: "active",
//       image: null,
//     });
//     if (imageInputRef.current) {
//       imageInputRef.current.value = "";
//     }
//   };


//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   // return (
//   //   <div className="mt-2">
//   //     <div className="card">
//   //       <div className="card-header">
//   //         <div className="d-flex align-items-center justify-content-between">
//   //           <div className="titlepage">
//   //             <h3>Active Block</h3>
//   //           </div>
//   //           <div className="d-flex gap-2">

//   //             <div className="createnewadmin">
//   //               <Link to="/create-block" className="btn btn-success d-inline-flex align-items-center">
//   //                 <FaPlus className="me-2" /> Create New Block
//   //               </Link>
//   //             </div>
//   //           </div>
//   //         </div>
//   //       </div>
//   //       <div className="card-body">

//   //         <div className="table-responsive">
//   //           <Table bordered>
//   //             <thead className="bg-primary text-white">
//   //               <tr>
//   //                 <th>ID</th>
//   //                 <th>Project Name</th>
//   //                 <th>Block Name</th>
//   //                 <th>Image</th>
//   //                 <th>Date</th>
//   //                 <th>Status</th>
//   //                 <th>Actions</th>
//   //               </tr>
//   //             </thead>
//   //             <tbody>
//   //               {blocks.length > 0 ? (
//   //                 blocks.map((block) => (
//   //                   <tr key={block.id}>
//   //                     <td>{block.id}</td>
//   //                     <td>{block.project_name}</td>
//   //                     <td>{block.name}</td>
//   //                     <td>
//   //                       {block.image ? (
//   //                         <img
//   //                           src={`${imageAPIURL}/block/${block.image}`}
//   //                           alt={`Block ${block.name}`}
//   //                           style={{ width: "100px", height: "auto", borderRadius: "5px" }}
//   //                           onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/100x50/cccccc/333333?text=No+Image"; }}
//   //                         />
//   //                       ) : (
//   //                         "No Image"
//   //                       )}
//   //                     </td>
//   //                     <td>{block.date}</td>
//   //                     <td>
//   //                       <span
//   //                         className={`badge ${block.status === "active" ? "bg-success" : "bg-danger"
//   //                           }`}
//   //                       >
//   //                         {block.status}
//   //                       </span>
//   //                     </td>
//   //                     <td>
//   //                       <div className="dropdown">
//   //                         <button
//   //                           className="btn light btn-action dropdown-toggle"
//   //                           type="button"
//   //                           id="dropdownMenuButton"
//   //                           data-bs-toggle="dropdown"
//   //                           aria-expanded="false"
//   //                         >
//   //                           <BsThreeDots size={20} />
//   //                         </button>
//   //                         <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               className="btn view_btn btn-sm me-1"
//   //                               onClick={() => handleViewBlock(block.id)}
//   //                               title="View Project Details"
//   //                             >
//   //                               <FaEye /> View
//   //                             </button>
//   //                           </li>
//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               className="btn edit_btn btn-sm me-1"
//   //                               onClick={() => handleEditBlock(block.id)}
//   //                               title="Edit Project"
//   //                             >
//   //                               <FaEdit /> Edit
//   //                             </button>
//   //                           </li>

//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               className="btn btn-danger btn-sm"
//   //                               variant={block.status === "active" ? "danger" : "success"}
//   //                               onClick={() => handleStatusUpdate(block.id, block.status)}
//   //                             >
//   //                               {block.status === "active" ? <MdAirplanemodeInactive /> : <MdAirplanemodeActive />}
//   //                               {block.status === "active" ? "Deactivate" : "Activate"}
//   //                             </button>
//   //                           </li>
//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               className="btn delete_btn btn-sm"
//   //                               onClick={() => handleDeleteBlock(block.id)}
//   //                               title="Delete Project"
//   //                             >
//   //                               <RiDeleteBin3Fill /> Delete
//   //                             </button>
//   //                           </li>
//   //                         </ul>
//   //                       </div>
//   //                     </td>
//   //                   </tr>
//   //                 ))
//   //               ) : (
//   //                 <tr>
//   //                   <td colSpan="6" className="text-center">
//   //                     No blocks found.
//   //                   </td>
//   //                 </tr>
//   //               )}
//   //             </tbody>
//   //           </Table>
//   //         </div>


//   //         <div className="d-flex justify-content-end">
//   //           <Pagination>
//   //             {/* <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} /> */}
//   //             <Pagination.Prev
//   //               onClick={() => handlePageChange(currentPage - 1)}
//   //               disabled={currentPage === 1}
//   //             >
//   //             </Pagination.Prev>
//   //             {[...Array(totalPages)].map((_, index) => (
//   //               <Pagination.Item
//   //                 key={index + 1}
//   //                 active={index + 1 === currentPage}
//   //                 onClick={() => handlePageChange(index + 1)}
//   //               >
//   //                 {index + 1}
//   //               </Pagination.Item>
//   //             ))}
//   //             <Pagination.Next
//   //               onClick={() => handlePageChange(currentPage + 1)}
//   //               disabled={currentPage === totalPages}
//   //             >
//   //             </Pagination.Next>
//   //             {/* <Pagination.Last
//   //           onClick={() => handlePageChange(totalPages)}
//   //           disabled={currentPage === totalPages}
//   //         /> */}
//   //           </Pagination>
//   //         </div>
//   //       </div>
//   //     </div>




//   //     <Modal show={showViewModal} onHide={handleCloseViewModal} centered>
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Block Details</Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body>
//   //         {selectedBlock && (
           
//   //           <table className="table">
//   //             <tbody>
               
//   //               <tr>
//   //                 <th>Project Name</th>
//   //                 <td>{selectedBlock.project_name}</td>
//   //               </tr>
//   //               <tr>
//   //                 <th>Block Name</th>
//   //                 <td>{selectedBlock.name}</td>
//   //               </tr>
//   //               <tr>
//   //                 <th>Status</th>
//   //                 <td>
//   //                   <span
//   //                     className={`badge ${selectedBlock.status === "active" ? "bg-success" : "bg-danger"
//   //                       }`}
//   //                   >
//   //                     {selectedBlock.status}
//   //                   </span>
//   //                 </td>
//   //               </tr>

//   //               {selectedBlock.image && (
//   //                 <tr>
//   //                   <th>Image</th>
//   //                   <td>
//   //                     <img
//   //                       src={`${imageAPIURL}/block/${selectedBlock.image}`}
//   //                       alt={selectedBlock.name}
//   //                       className="img-fluid rounded"
//   //                       style={{ maxWidth: "200px" }}
//   //                       onError={(e) => {
//   //                         e.target.onerror = null;
//   //                         e.target.src =
//   //                           "https://placehold.co/200x100/cccccc/333333?text=No+Image";
//   //                       }}
//   //                     />
//   //                   </td>
//   //                 </tr>
//   //               )}
//   //             </tbody>
//   //           </table>

//   //         )}
//   //       </Modal.Body>
//   //       <Modal.Footer>
//   //         <Button variant="secondary" onClick={handleCloseViewModal}>
//   //           Close
//   //         </Button>
//   //       </Modal.Footer>
//   //     </Modal>


//   //     <Modal show={showEditModal} onHide={handleCloseEditModal} centered>
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Edit Block</Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body>
//   //         <Form onSubmit={handleUpdateBlock}>
//   //           <Form.Group className="mb-3" controlId="editBlockName">
//   //             <Form.Label>Block Name</Form.Label>
//   //             <Form.Control
//   //               type="text"
//   //               name="name"
//   //               value={editFormData.name}
//   //               onChange={handleEditFormChange}
//   //               required
//   //             />
//   //           </Form.Group>
//   //           <Form.Group className="mb-3" controlId="editBlockStatus">
//   //             <Form.Label>Status</Form.Label>
//   //             <Form.Select
//   //               name="status"
//   //               value={editFormData.status}
//   //               onChange={handleEditFormChange}
//   //               required
//   //             >
//   //               <option value="active">Active</option>
//   //               <option value="inactive">Inactive</option>
//   //             </Form.Select>
//   //           </Form.Group>
//   //           <Form.Group className="mb-3" controlId="editBlockImage">
//   //             <Form.Label>Block Image</Form.Label>
//   //             <Form.Control
//   //               type="file"
//   //               name="image"
//   //               accept="image/*"
//   //               onChange={handleEditFormChange}
//   //               ref={imageInputRef}
//   //             />
//   //             {selectedBlock && selectedBlock.image && (
//   //               <div className="mt-2">
//   //                 <small className="text-muted">Current Image:</small>
//   //                 <img
//   //                   src={`${imageAPIURL}/block/${selectedBlock.image}`}
//   //                   alt="Current Block"
//   //                   className="img-thumbnail ms-2"
//   //                   style={{ maxWidth: "100px", maxHeight: "100px" }}
//   //                   onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/100x50/cccccc/333333?text=No+Image"; }}
//   //                 />
//   //               </div>
//   //             )}
//   //           </Form.Group>
//   //           <Button variant="primary" type="submit" className="w-100" disabled={loading}>
//   //             {loading ? "Updating..." : "Update Block"}
//   //           </Button>
//   //         </Form>
//   //       </Modal.Body>
//   //     </Modal>


//   //     {showMessageModal && (
//   //       <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
//   //         <div className="modal-dialog modal-dialog-centered">
//   //           <div className={`modal-content ${messageModalContent.type === 'success' ? '' : messageModalContent.type === 'error' ? '' : ''}`}>
//   //             <div className="modal-header d-flex justify-content-between align-items-center">
//   //               <h5 className={`modal-title ${messageModalContent.type === 'success' ? '' : messageModalContent.type === 'error' ? '' : ''}`}>
//   //                 {messageModalContent.title}
//   //               </h5>
//   //               <button type="button" className="btn-close" aria-label="Close" onClick={closeCustomMessageModal}></button>
//   //             </div>
//   //             <div className="modal-body text-secondary">
//   //               <p>{messageModalContent.text}</p>
//   //             </div>
//   //             <div className="modal-footer justify-content-center">
//   //               {messageModalContent.confirmAction ? (
//   //                 <>
//   //                   <Button
//   //                     variant={messageModalContent.type === 'btn-primary-custum' ? 'btn-primary-custum' : 'primary'}
//   //                     onClick={() => {
//   //                       messageModalContent.confirmAction();
//   //                       closeCustomMessageModal();
//   //                     }}
//   //                   >
//   //                     Confirm
//   //                   </Button>
//   //                   <Button
//   //                     variant="danger"
//   //                     onClick={closeCustomMessageModal}
//   //                   >
//   //                     Cancel
//   //                   </Button>
                  
//   //                 </>
//   //               ) : (
//   //                 <Button
//   //                   variant={messageModalContent.type === 'success' ? 'success' : messageModalContent.type === 'error' ? 'danger' : 'primary'}
//   //                   onClick={closeCustomMessageModal}
//   //                 >
//   //                   OK
//   //                 </Button>
//   //               )}
//   //             </div>
//   //           </div>
//   //         </div>
//   //       </div>
//   //     )}
//   //   </div>
//   // );
// return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               🏢
//             </div>
//             <div style={{ flex: 1 }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Active Block
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Manage all your active blocks here
//               </p>
//             </div>
//             <Link
//               to="/create-block"
//               style={{
//                 padding: "12px 24px",
//                 borderRadius: "12px",
//                 border: "none",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 color: "#ffffff",
//                 fontSize: "14px",
//                 fontWeight: "700",
//                 letterSpacing: "0.5px",
//                 textDecoration: "none",
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 boxShadow: "0 8px 24px rgba(30, 87, 153, 0.3)",
//                 transition: "all 0.3s ease",
//               }}
//             >
//               <FaPlus /> Create New Block
//             </Link>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "24px" }}>
//               <div className="table-responsive">
//                 <Table bordered hover>
//                   <thead
//                     style={{
//                       background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                       color: "#ffffff",
//                     }}
//                   >
//                     <tr>
//                       <th>ID</th>
//                       <th>Project Name</th>
//                       <th>Block Name</th>
//                       <th>Image</th>
//                       <th>Date</th>
//                       <th>Status</th>
//                       <th>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {blocks.length > 0 ? (
//                       blocks.map((block) => (
//                         <tr key={block.id}>
//                           <td>{block.id}</td>
//                           <td>{block.project_name}</td>
//                           <td>{block.name}</td>
//                           <td>
//                             {block.image ? (
//                               <img
//                                 src={`${imageAPIURL}/block/${block.image}`}
//                                 alt={`Block ${block.name}`}
//                                 style={{
//                                   width: "80px",
//                                   height: "50px",
//                                   objectFit: "cover",
//                                   borderRadius: "8px",
//                                 }}
//                                 onError={(e) => {
//                                   e.target.onerror = null;
//                                   e.target.src =
//                                     "https://placehold.co/100x50/cccccc/333333?text=No+Image";
//                                 }}
//                               />
//                             ) : (
//                               "No Image"
//                             )}
//                           </td>
//                           <td>{block.date}</td>
//                           <td>
//                             <span
//                               className={`badge ${
//                                 block.status === "active"
//                                   ? "bg-success"
//                                   : "bg-danger"
//                               }`}
//                             >
//                               {block.status}
//                             </span>
//                           </td>
//                           <td>
//                             <div className="dropdown">
//                               <button
//                                 className="btn light btn-action dropdown-toggle"
//                                 type="button"
//                                 id={`dropdownMenuButton-${block.id}`}
//                                 data-bs-toggle="dropdown"
//                                 aria-expanded="false"
//                               >
//                                 <BsThreeDots size={20} />
//                               </button>
//                               <ul
//                                 className="dropdown-menu"
//                                 aria-labelledby={`dropdownMenuButton-${block.id}`}
//                               >
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn view_btn btn-sm me-1"
//                                     onClick={() => handleViewBlock(block.id)}
//                                     title="View Block Details"
//                                   >
//                                     <FaEye /> View
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn edit_btn btn-sm me-1"
//                                     onClick={() => handleEditBlock(block.id)}
//                                     title="Edit Block"
//                                   >
//                                     <FaEdit /> Edit
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn btn-danger btn-sm"
//                                     onClick={() =>
//                                       handleStatusUpdate(block.id, block.status)
//                                     }
//                                   >
//                                     {block.status === "active" ? (
//                                       <MdAirplanemodeInactive />
//                                     ) : (
//                                       <MdAirplanemodeActive />
//                                     )}
//                                     {block.status === "active"
//                                       ? "Deactivate"
//                                       : "Activate"}
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn delete_btn btn-sm"
//                                     onClick={() => handleDeleteBlock(block.id)}
//                                     title="Delete Block"
//                                   >
//                                     <RiDeleteBin3Fill /> Delete
//                                   </button>
//                                 </li>
//                               </ul>
//                             </div>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="7" className="text-center py-4">
//                           No blocks found.
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </Table>
//               </div>

//               {/* 🎯 PAGINATION */}
//               <div className="d-flex justify-content-end mt-3">
//                 <Pagination>
//                   <Pagination.Prev
//                     onClick={() => handlePageChange(currentPage - 1)}
//                     disabled={currentPage === 1}
//                   />
//                   {[...Array(totalPages)].map((_, index) => (
//                     <Pagination.Item
//                       key={index + 1}
//                       active={index + 1 === currentPage}
//                       onClick={() => handlePageChange(index + 1)}
//                     >
//                       {index + 1}
//                     </Pagination.Item>
//                   ))}
//                   <Pagination.Next
//                     onClick={() => handlePageChange(currentPage + 1)}
//                     disabled={currentPage === totalPages}
//                   />
//                 </Pagination>
//               </div>
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       {/* 🎯 VIEW MODAL */}
//       <Modal show={showViewModal} onHide={handleCloseViewModal} centered>
//         <Modal.Header closeButton>
//           <Modal.Title style={{ color: "#1e3a5f", fontWeight: "800" }}>
//             Block Details
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selectedBlock && (
//             <table className="table">
//               <tbody>
//                 <tr>
//                   <th>Project Name</th>
//                   <td>{selectedBlock.project_name}</td>
//                 </tr>
//                 <tr>
//                   <th>Block Name</th>
//                   <td>{selectedBlock.name}</td>
//                 </tr>
//                 <tr>
//                   <th>Status</th>
//                   <td>
//                     <span
//                       className={`badge ${
//                         selectedBlock.status === "active"
//                           ? "bg-success"
//                           : "bg-danger"
//                       }`}
//                     >
//                       {selectedBlock.status}
//                     </span>
//                   </td>
//                 </tr>
//                 {selectedBlock.image && (
//                   <tr>
//                     <th>Image</th>
//                     <td>
//                       <img
//                         src={`${imageAPIURL}/block/${selectedBlock.image}`}
//                         alt={selectedBlock.name}
//                         className="img-fluid rounded"
//                         style={{ maxWidth: "200px" }}
//                         onError={(e) => {
//                           e.target.onerror = null;
//                           e.target.src =
//                             "https://placehold.co/200x100/cccccc/333333?text=No+Image";
//                         }}
//                       />
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCloseViewModal}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* 🎯 EDIT MODAL */}
//       <Modal show={showEditModal} onHide={handleCloseEditModal} centered>
//         <Modal.Header closeButton>
//           <Modal.Title style={{ color: "#1e3a5f", fontWeight: "800" }}>
//             Edit Block
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleUpdateBlock}>
//             <Form.Group className="mb-3" controlId="editBlockName">
//               <Form.Label>Block Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="name"
//                 value={editFormData.name}
//                 onChange={handleEditFormChange}
//                 required
//               />
//             </Form.Group>
//             <Form.Group className="mb-3" controlId="editBlockStatus">
//               <Form.Label>Status</Form.Label>
//               <Form.Select
//                 name="status"
//                 value={editFormData.status}
//                 onChange={handleEditFormChange}
//                 required
//               >
//                 <option value="active">Active</option>
//                 <option value="inactive">Inactive</option>
//               </Form.Select>
//             </Form.Group>
//             <Form.Group className="mb-3" controlId="editBlockImage">
//               <Form.Label>Block Image</Form.Label>
//               <Form.Control
//                 type="file"
//                 name="image"
//                 accept="image/*"
//                 onChange={handleEditFormChange}
//                 ref={imageInputRef}
//               />
//               {selectedBlock && selectedBlock.image && (
//                 <div className="mt-2">
//                   <small className="text-muted">Current Image:</small>
//                   <img
//                     src={`${imageAPIURL}/block/${selectedBlock.image}`}
//                     alt="Current Block"
//                     className="img-thumbnail ms-2"
//                     style={{ maxWidth: "100px", maxHeight: "100px" }}
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src =
//                         "https://placehold.co/100x50/cccccc/333333?text=No+Image";
//                     }}
//                   />
//                 </div>
//               )}
//             </Form.Group>
//             <Button
//               variant="primary"
//               type="submit"
//               className="w-100"
//               disabled={loading}
//             >
//               {loading ? "Updating..." : "Update Block"}
//             </Button>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* 🎯 MESSAGE MODAL */}
//       {showMessageModal && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div
//               className={`modal-content ${
//                 messageModalContent.type === "success" ? "border-success" : ""
//               }`}
//             >
//               <div className="modal-header d-flex justify-content-between align-items-center">
//                 <h5
//                   className={`modal-title ${
//                     messageModalContent.type === "success"
//                       ? "text-success"
//                       : messageModalContent.type === "error"
//                       ? "text-danger"
//                       : "text-warning"
//                   }`}
//                 >
//                   {messageModalContent.title}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   aria-label="Close"
//                   onClick={closeCustomMessageModal}
//                 ></button>
//               </div>
//               <div className="modal-body text-secondary">
//                 <p>{messageModalContent.text}</p>
//               </div>
//               <div className="modal-footer justify-content-center">
//                 {messageModalContent.confirmAction ? (
//                   <>
//                     <Button
//                       variant="secondary"
//                       onClick={closeCustomMessageModal}
//                     >
//                       Cancel
//                     </Button>
//                     <Button
//                       variant={
//                         messageModalContent.type === "warning"
//                           ? "warning"
//                           : "primary"
//                       }
//                       onClick={() => {
//                         messageModalContent.confirmAction();
//                         closeCustomMessageModal();
//                       }}
//                     >
//                       Confirm
//                     </Button>
//                   </>
//                 ) : (
//                   <Button
//                     variant={
//                       messageModalContent.type === "success"
//                         ? "success"
//                         : messageModalContent.type === "error"
//                         ? "danger"
//                         : "primary"
//                     }
//                     onClick={closeCustomMessageModal}
//                   >
//                     OK
//                   </Button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default ActiveBlockList;

// import React, { useEffect, useState, useRef } from "react";
// import { Link } from "react-router-dom";
// import { FaPlus, FaEye, FaEdit } from "react-icons/fa";
// import { Modal, Button, Form, Row, Col } from "react-bootstrap";
// import { RiDeleteBin3Fill } from "react-icons/ri";
// import { BsThreeDots } from "react-icons/bs";
// import {
//   MdAirplanemodeInactive,
//   MdAirplanemodeActive,
// } from "react-icons/md";

// const API_URL = process.env.REACT_APP_API_URL;
// const imageAPIURL = process.env.REACT_APP_Image_URL;

// function ActiveBlockList() {
//   const [blocks, setBlocks] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [showEditModal, setShowEdit] = useState(false);
//   const [selectedBlock, setSelectedBlock] = useState(null);
//   const [selectedimagePath, setSelectedimagePath] = useState(null);
//   const [editFormData, setEditFormData] = useState({
//     id: "",
//     name: "",
//     status: "active",
//     image: null,
//   });
//   const imageInputRef = useRef(null);

//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//   });

//   const getAuthToken = () => localStorage.getItem("token");

//   const showCustomMessageModal = (title, text, type, confirmAction = null) => {
//     setMessageModalContent({ title, text, type, confirmAction });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//     setMessageModalContent({
//       title: "",
//       text: "",
//       type: "",
//       confirmAction: null,
//     });
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 FETCH ACTIVE BLOCKS
//   // ═══════════════════════════════════════════
//   const fetchBlocks = async (page = 1) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error"
//         );
//         return;
//       }

//       const response = await fetch(
//         `${API_URL}/block-list-active?page=${page}&limit=10`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (!response.ok) {
//         if (response.status === 401) {
//           showCustomMessageModal(
//             "Authorization Error",
//             "Unauthorized: Please log in again.",
//             "error"
//           );
//         }
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to fetch blocks.");
//       }

//       const data = await response.json();
//       setBlocks(data.data || []);
//       setSelectedimagePath(data.imagePath);
//       setTotalPages(data.data?.totalPages || 1);
//       setCurrentPage(page);
//     } catch (err) {
//       console.error("Fetch blocks error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchBlocks(currentPage);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [currentPage]);

//   const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

//   // ═══════════════════════════════════════════
//   // 🔹 VIEW BLOCK
//   // ═══════════════════════════════════════════
//   const handleViewBlock = async (blockId) => {
//     setLoading(true);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Please log in.",
//           "error"
//         );
//         return;
//       }

//       const response = await fetch(`${API_URL}/block-view`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id: blockId }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to fetch block details.");
//       }

//       const data = await response.json();
//       setSelectedBlock(data.data);
//       setShowViewModal(true);
//     } catch (err) {
//       console.error("View block error:", err);
//       showCustomMessageModal("Error", err.message, "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 EDIT BLOCK
//   // ═══════════════════════════════════════════
//   const handleEditBlock = async (blockId) => {
//     setLoading(true);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Please log in.",
//           "error"
//         );
//         return;
//       }

//       const response = await fetch(`${API_URL}/block-edit`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id: blockId }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(
//           errorData.message || "Failed to fetch block for editing."
//         );
//       }

//       const data = await response.json();
//       const blockData = data.data;
//       setSelectedBlock(blockData);
//       setEditFormData({
//         id: blockData.id,
//         name: blockData.name || "",
//         status: blockData.status || "active",
//         image: null,
//       });
//       setShowEdit(true);
//     } catch (err) {
//       console.error("Edit block error:", err);
//       showCustomMessageModal("Error", err.message, "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditFormChange = (e) => {
//     const { name, value, files } = e.target;
//     if (name === "image") {
//       setEditFormData((prev) => ({ ...prev, image: files[0] }));
//     } else {
//       setEditFormData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 UPDATE BLOCK
//   // ═══════════════════════════════════════════
//   const handleUpdateBlock = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Please log in.",
//           "error"
//         );
//         return;
//       }

//       const formDataToSend = new FormData();
//       formDataToSend.append("project_id", editFormData.id);
//       formDataToSend.append("name", editFormData.name);
//       formDataToSend.append("status", editFormData.status);
//       if (editFormData.image) {
//         formDataToSend.append("image", editFormData.image);
//       }

//       const response = await fetch(`${API_URL}/block-update`, {
//         method: "POST",
//         headers: { Authorization: `Bearer ${token}` },
//         body: formDataToSend,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to update block.");
//       }

//       showCustomMessageModal(
//         "Success",
//         "Block updated successfully!",
//         "success"
//       );
//       setShowEdit(false);
//       fetchBlocks(currentPage);
//     } catch (err) {
//       console.error("Update block error:", err);
//       showCustomMessageModal("Error", err.message, "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 STATUS UPDATE
//   // ═══════════════════════════════════════════
//   const handleStatusUpdate = (blockId, currentStatus) => {
//     const newStatus = currentStatus === "active" ? "inactive" : "active";
//     showCustomMessageModal(
//       "Confirm Status Change",
//       `Do you want to change the status to ${newStatus}?`,
//       "warning",
//       async () => {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           const response = await fetch(`${API_URL}/block-status-update`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ id: blockId, status: newStatus }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to update status.");
//           }

//           const result = await response.json();
//           if (result.success == "1") {
//             showCustomMessageModal(
//               "Success",
//               "Block status updated successfully!",
//               "success"
//             );
//             fetchBlocks(currentPage);
//           } else {
//             showCustomMessageModal(
//               "Error",
//               result.message || "Something went wrong!",
//               "error"
//             );
//           }
//         } catch (err) {
//           showCustomMessageModal("Error", err.message, "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 DELETE BLOCK
//   // ═══════════════════════════════════════════
//   const handleDeleteBlock = (blockId) => {
//     showCustomMessageModal(
//       "Confirm Deletion",
//       "Are you sure you want to delete this block? This action cannot be undone.",
//       "warning",
//       async () => {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           const response = await fetch(`${API_URL}/block-delete`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ id: blockId }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to delete block.");
//           }

//           showCustomMessageModal(
//             "Success",
//             "Block deleted successfully!",
//             "success"
//           );
//           fetchBlocks(currentPage);
//         } catch (err) {
//           showCustomMessageModal("Error", err.message, "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     );
//   };

//   const handleCloseViewModal = () => {
//     setShowViewModal(false);
//     setSelectedBlock(null);
//   };

//   const handleCloseEditModal = () => {
//     setShowEdit(false);
//     setSelectedBlock(null);
//     setEditFormData({ id: "", name: "", status: "active", image: null });
//     if (imageInputRef.current) imageInputRef.current.value = "";
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 LOADING
//   // ═══════════════════════════════════════════
//   if (loading) {
//     return (
//       <div
//         style={{
//           minHeight: "80vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//         }}
//       >
//         <div
//           style={{
//             width: "50px",
//             height: "50px",
//             border: "4px solid #e2e8f0",
//             borderTop: "4px solid #1e5799",
//             borderRadius: "50%",
//             animation: "spin 0.8s linear infinite",
//           }}
//         />
//         <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
//       </div>
//     );
//   }

//   // ═══════════════════════════════════════════
//   // 🎨 UI RENDER
//   // ═══════════════════════════════════════════
//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//         padding: "24px",
//         fontFamily: "'Poppins', 'DM Sans', sans-serif",
//       }}
//     >
//       <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
//         <div
//           style={{
//             background: "#ffffff",
//             borderRadius: "20px",
//             boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
//             border: "1.5px solid #e2e8f0",
//             overflow: "hidden",
//           }}
//         >
//           {/* Top Gradient */}
//           <div
//             style={{
//               height: "5px",
//               background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//             }}
//           />

//           {/* Header */}
//           <div
//             style={{
//               padding: "24px 30px",
//               background: "linear-gradient(135deg, #ffffff, #f8fafc)",
//               borderBottom: "1.5px solid #e2e8f0",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               gap: "16px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
//               <div
//                 style={{
//                   width: "48px",
//                   height: "48px",
//                   borderRadius: "14px",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   color: "#ffffff",
//                   fontSize: "22px",
//                   boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                   flexShrink: 0,
//                 }}
//               >
//                 ✅
//               </div>
//               <div>
//                 <h2
//                   style={{
//                     margin: 0,
//                     fontSize: "22px",
//                     fontWeight: "800",
//                     color: "#1e3a5f",
//                     letterSpacing: "-0.3px",
//                   }}
//                 >
//                   Active Blocks
//                 </h2>
//                 <p
//                   style={{
//                     margin: "2px 0 0",
//                     fontSize: "12.5px",
//                     color: "#64748b",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Manage all your active blocks
//                 </p>
//               </div>
//             </div>

//             <Link
//               to="/create-block"
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 padding: "10px 20px",
//                 borderRadius: "10px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 color: "#ffffff",
//                 fontSize: "13px",
//                 fontWeight: "700",
//                 textDecoration: "none",
//                 boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
//               }}
//             >
//               <FaPlus /> Create New Block
//             </Link>
//           </div>

//           {/* Body */}
//           <div style={{ padding: "24px 30px" }}>
//             <div
//               style={{
//                 overflowX: "auto",
//                 overflowY: "visible",
//                 borderRadius: "14px",
//                 border: "1.5px solid #e2e8f0",
//               }}
//             >
//               <table
//                 style={{
//                   width: "100%",
//                   borderCollapse: "collapse",
//                   fontSize: "13px",
//                 }}
//               >
//                 <thead>
//                   <tr
//                     style={{
//                       background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                     }}
//                   >
//                     {[
//                       "#",
//                       "Project Name",
//                       "Block Name",
//                       "Image",
//                       "Date",
//                       "Status",
//                       "Actions",
//                     ].map((th, i) => (
//                       <th
//                         key={i}
//                         style={{
//                           padding: "14px 12px",
//                           color: "#ffffff",
//                           fontWeight: "700",
//                           fontSize: "11.5px",
//                           textAlign: "left",
//                           letterSpacing: "0.5px",
//                           textTransform: "uppercase",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         {th}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {blocks.length > 0 ? (
//                     blocks.map((block, index) => (
//                       <tr
//                         key={block.id}
//                         style={{ borderBottom: "1px solid #f1f5f9" }}
//                         onMouseEnter={(e) =>
//                           (e.currentTarget.style.background = "#f8fafc")
//                         }
//                         onMouseLeave={(e) =>
//                           (e.currentTarget.style.background = "transparent")
//                         }
//                       >
//                         <td
//                           style={{
//                             padding: "12px",
//                             fontWeight: "700",
//                             color: "#1e5799",
//                           }}
//                         >
//                           {(currentPage - 1) * 10 + index + 1}
//                         </td>
//                         <td
//                           style={{
//                             padding: "12px",
//                             fontWeight: "600",
//                             color: "#1e3a5f",
//                           }}
//                         >
//                           {block.project_name}
//                         </td>
//                         <td
//                           style={{
//                             padding: "12px",
//                             fontWeight: "600",
//                             color: "#334155",
//                           }}
//                         >
//                           {block.name}
//                         </td>
//                         <td style={{ padding: "12px" }}>
//                           {block.image ? (
//                             <img
//                               src={`${imageAPIURL}/block/${block.image}`}
//                               alt={`Block ${block.name}`}
//                               style={{
//                                 width: "70px",
//                                 height: "50px",
//                                 objectFit: "cover",
//                                 borderRadius: "8px",
//                                 border: "1.5px solid #e2e8f0",
//                               }}
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src =
//                                   "https://placehold.co/100x50/cccccc/333333?text=No+Image";
//                               }}
//                             />
//                           ) : (
//                             <span
//                               style={{
//                                 color: "#94a3b8",
//                                 fontSize: "12px",
//                                 fontWeight: "600",
//                               }}
//                             >
//                               —
//                             </span>
//                           )}
//                         </td>
//                         <td
//                           style={{
//                             padding: "12px",
//                             color: "#64748b",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {block.date}
//                         </td>
//                         <td style={{ padding: "12px" }}>
//                           <span
//                             style={{
//                               display: "inline-block",
//                               padding: "4px 12px",
//                               borderRadius: "20px",
//                               fontSize: "11.5px",
//                               fontWeight: "700",
//                               background:
//                                 block.status === "active"
//                                   ? "#e7f9eb"
//                                   : "#feeaeb",
//                               color:
//                                 block.status === "active"
//                                   ? "#059669"
//                                   : "#dc2626",
//                               textTransform: "capitalize",
//                             }}
//                           >
//                             {block.status}
//                           </span>
//                         </td>
//                         <td style={{ padding: "12px" }}>
//                           <div className="dropdown">
//                             <button
//                               className="btn dropdown-toggle"
//                               type="button"
//                               data-bs-toggle="dropdown"
//                               data-bs-boundary="viewport"
//                               data-bs-popper-config='{"strategy":"fixed"}'
//                               aria-expanded="false"
//                               style={{
//                                 background: "#f8fafc",
//                                 border: "1.5px solid #e2e8f0",
//                                 borderRadius: "8px",
//                                 width: "36px",
//                                 height: "36px",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 color: "#1e5799",
//                                 padding: 0,
//                               }}
//                             >
//                               <BsThreeDots size={18} />
//                             </button>
//                             <ul
//                               className="dropdown-menu"
//                               style={{
//                                 zIndex: 9999,
//                                 borderRadius: "14px",
//                                 border: "none",
//                                 padding: "8px",
//                                 boxShadow:
//                                   "0 12px 40px rgba(30, 87, 153, 0.18), 0 4px 12px rgba(0,0,0,0.06)",
//                                 minWidth: "230px",
//                                 marginTop: "8px",
//                                 background: "#ffffff",
//                               }}
//                             >
//                               {/* View */}
//                               <li>
//                                 <button
//                                   className="dropdown-item d-flex align-items-center"
//                                   onClick={() => handleViewBlock(block.id)}
//                                   style={dropdownItem}
//                                   onMouseEnter={(e) => {
//                                     e.currentTarget.style.background = "#e8f1fb";
//                                     e.currentTarget.style.transform =
//                                       "translateX(3px)";
//                                   }}
//                                   onMouseLeave={(e) => {
//                                     e.currentTarget.style.background =
//                                       "transparent";
//                                     e.currentTarget.style.transform =
//                                       "translateX(0)";
//                                   }}
//                                 >
//                                   <span style={iconBadge("#e8f1fb", "#1e5799")}>
//                                     <FaEye size={13} />
//                                   </span>
//                                   View Details
//                                 </button>
//                               </li>

//                               {/* Edit */}
//                               <li>
//                                 <button
//                                   className="dropdown-item d-flex align-items-center"
//                                   onClick={() => handleEditBlock(block.id)}
//                                   style={dropdownItem}
//                                   onMouseEnter={(e) => {
//                                     e.currentTarget.style.background = "#e7f9eb";
//                                     e.currentTarget.style.transform =
//                                       "translateX(3px)";
//                                   }}
//                                   onMouseLeave={(e) => {
//                                     e.currentTarget.style.background =
//                                       "transparent";
//                                     e.currentTarget.style.transform =
//                                       "translateX(0)";
//                                   }}
//                                 >
//                                   <span style={iconBadge("#e7f9eb", "#059669")}>
//                                     <FaEdit size={13} />
//                                   </span>
//                                   Edit Block
//                                 </button>
//                               </li>

//                               <li>
//                                 <hr
//                                   style={{
//                                     margin: "6px 8px",
//                                     border: "none",
//                                     borderTop: "1.5px dashed #e2e8f0",
//                                   }}
//                                 />
//                               </li>

//                               {/* Activate / Deactivate */}
//                               <li>
//                                 <button
//                                   className="dropdown-item d-flex align-items-center"
//                                   onClick={() =>
//                                     handleStatusUpdate(block.id, block.status)
//                                   }
//                                   style={{
//                                     ...dropdownItem,
//                                     color:
//                                       block.status === "active"
//                                         ? "#dc2626"
//                                         : "#059669",
//                                   }}
//                                   onMouseEnter={(e) => {
//                                     e.currentTarget.style.background =
//                                       block.status === "active"
//                                         ? "#feeaeb"
//                                         : "#e7f9eb";
//                                     e.currentTarget.style.transform =
//                                       "translateX(3px)";
//                                   }}
//                                   onMouseLeave={(e) => {
//                                     e.currentTarget.style.background =
//                                       "transparent";
//                                     e.currentTarget.style.transform =
//                                       "translateX(0)";
//                                   }}
//                                 >
//                                   <span
//                                     style={iconBadge(
//                                       block.status === "active"
//                                         ? "#feeaeb"
//                                         : "#e7f9eb",
//                                       block.status === "active"
//                                         ? "#dc2626"
//                                         : "#059669"
//                                     )}
//                                   >
//                                     {block.status === "active" ? (
//                                       <MdAirplanemodeInactive size={13} />
//                                     ) : (
//                                       <MdAirplanemodeActive size={13} />
//                                     )}
//                                   </span>
//                                   {block.status === "active"
//                                     ? "Deactivate"
//                                     : "Activate"}
//                                 </button>
//                               </li>

//                               <li>
//                                 <hr
//                                   style={{
//                                     margin: "6px 8px",
//                                     border: "none",
//                                     borderTop: "1.5px dashed #e2e8f0",
//                                   }}
//                                 />
//                               </li>

//                               {/* Delete */}
//                               <li>
//                                 <button
//                                   className="dropdown-item d-flex align-items-center"
//                                   onClick={() => handleDeleteBlock(block.id)}
//                                   style={{ ...dropdownItem, color: "#dc2626" }}
//                                   onMouseEnter={(e) => {
//                                     e.currentTarget.style.background = "#feeaeb";
//                                     e.currentTarget.style.transform =
//                                       "translateX(3px)";
//                                   }}
//                                   onMouseLeave={(e) => {
//                                     e.currentTarget.style.background =
//                                       "transparent";
//                                     e.currentTarget.style.transform =
//                                       "translateX(0)";
//                                   }}
//                                 >
//                                   <span style={iconBadge("#feeaeb", "#dc2626")}>
//                                     <RiDeleteBin3Fill size={13} />
//                                   </span>
//                                   Delete Block
//                                 </button>
//                               </li>
//                             </ul>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan="7"
//                         style={{
//                           padding: "50px",
//                           textAlign: "center",
//                           color: "#94a3b8",
//                           fontWeight: "600",
//                         }}
//                       >
//                         📭 No blocks found.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             {totalPages > 1 && (
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "flex-end",
//                   marginTop: "20px",
//                   gap: "6px",
//                 }}
//               >
//                 <button
//                   onClick={() => handlePageChange(currentPage - 1)}
//                   disabled={currentPage === 1}
//                   style={paginationBtn(currentPage === 1)}
//                 >
//                   ‹
//                 </button>

//                 {[...Array(totalPages)].map((_, index) => (
//                   <button
//                     key={index}
//                     onClick={() => handlePageChange(index + 1)}
//                     style={{
//                       width: "38px",
//                       height: "38px",
//                       borderRadius: "10px",
//                       border:
//                         index + 1 === currentPage
//                           ? "none"
//                           : "1.5px solid #e2e8f0",
//                       background:
//                         index + 1 === currentPage
//                           ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
//                           : "#ffffff",
//                       color: index + 1 === currentPage ? "#ffffff" : "#334155",
//                       fontWeight: "700",
//                       fontSize: "13px",
//                       cursor: "pointer",
//                       boxShadow:
//                         index + 1 === currentPage
//                           ? "0 6px 16px rgba(30, 87, 153, 0.3)"
//                           : "none",
//                     }}
//                   >
//                     {index + 1}
//                   </button>
//                 ))}

//                 <button
//                   onClick={() => handlePageChange(currentPage + 1)}
//                   disabled={currentPage === totalPages}
//                   style={paginationBtn(currentPage === totalPages)}
//                 >
//                   ›
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* ═══════════════════════════════════════════ */}
//       {/* 🎯 VIEW MODAL */}
//       {/* ═══════════════════════════════════════════ */}
//       <Modal
//         show={showViewModal}
//         onHide={handleCloseViewModal}
//         centered
//         size="lg"
//         backdrop="static"
//         style={{ zIndex: 99999 }}
//       >
//         <Modal.Header
//           closeButton
//           style={{
//             background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//             color: "#ffffff",
//             border: "none",
//             padding: "18px 24px",
//           }}
//         >
//           <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
//             📋 Block Details
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body style={{ padding: "24px" }}>
//           {selectedBlock && (
//             <>
//               {selectedBlock.image && (
//                 <div style={{ marginBottom: "20px" }}>
//                   <img
//                     src={`${imageAPIURL}/block/${selectedBlock.image}`}
//                     alt={selectedBlock.name}
//                     style={{
//                       width: "100%",
//                       maxHeight: "280px",
//                       objectFit: "cover",
//                       borderRadius: "12px",
//                       border: "1.5px solid #e2e8f0",
//                       boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//                     }}
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src =
//                         "https://placehold.co/600x280/cccccc/333333?text=No+Image";
//                     }}
//                   />
//                 </div>
//               )}

//               <Row className="mb-3">
//                 <Col md={12}>
//                   <strong style={labelColor}>Project Name:</strong>
//                   <p style={textDark}>{selectedBlock.project_name || "N/A"}</p>
//                 </Col>
//               </Row>

//               <Row className="mb-3">
//                 <Col md={6}>
//                   <strong style={labelColor}>Block Name:</strong>
//                   <p style={textDark}>{selectedBlock.name || "N/A"}</p>
//                 </Col>
//                 <Col md={6}>
//                   <strong style={labelColor}>Status:</strong>
//                   <p style={{ margin: "4px 0" }}>
//                     <span
//                       style={{
//                         display: "inline-block",
//                         padding: "5px 14px",
//                         borderRadius: "20px",
//                         fontSize: "12px",
//                         fontWeight: "700",
//                         background:
//                           selectedBlock.status === "active"
//                             ? "#e7f9eb"
//                             : "#feeaeb",
//                         color:
//                           selectedBlock.status === "active"
//                             ? "#059669"
//                             : "#dc2626",
//                         textTransform: "capitalize",
//                       }}
//                     >
//                       {selectedBlock.status}
//                     </span>
//                   </p>
//                 </Col>
//               </Row>

//               {selectedBlock.date && (
//                 <Row className="mb-3">
//                   <Col md={6}>
//                     <strong style={labelColor}>Date:</strong>
//                     <p style={textDark}>{selectedBlock.date}</p>
//                   </Col>
//                 </Row>
//               )}

//               {selectedBlock.description && (
//                 <Row className="mb-3">
//                   <Col md={12}>
//                     <strong style={labelColor}>Description:</strong>
//                     <div
//                       style={{ margin: "4px 0", color: "#334155" }}
//                       dangerouslySetInnerHTML={{
//                         __html: selectedBlock.description,
//                       }}
//                     />
//                   </Col>
//                 </Row>
//               )}
//             </>
//           )}
//         </Modal.Body>
//         <Modal.Footer style={{ borderTop: "1.5px solid #e2e8f0" }}>
//           <Button
//             variant="secondary"
//             onClick={handleCloseViewModal}
//             style={{ borderRadius: "10px", fontWeight: "700", padding: "8px 24px" }}
//           >
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* ═══════════════════════════════════════════ */}
//       {/* 🎯 EDIT MODAL */}
//       {/* ═══════════════════════════════════════════ */}
//       <Modal
//         show={showEditModal}
//         onHide={handleCloseEditModal}
//         centered
//         size="lg"
//         backdrop="static"
//         style={{ zIndex: 99999 }}
//       >
//         <Modal.Header
//           closeButton
//           style={{
//             background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//             color: "#ffffff",
//             border: "none",
//             padding: "18px 24px",
//           }}
//         >
//           <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
//             ✏️ Edit Block
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body
//           style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
//         >
//           <Form onSubmit={handleUpdateBlock}>
//             <Form.Group className="mb-3">
//               <Form.Label style={labelStyle}>Block Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="name"
//                 value={editFormData.name}
//                 onChange={handleEditFormChange}
//                 required
//                 style={{
//                   borderRadius: "10px",
//                   padding: "10px 14px",
//                   border: "1.5px solid #e2e8f0",
//                   fontSize: "13.5px",
//                 }}
//               />
//             </Form.Group>

//             <Form.Group className="mb-3">
//               <Form.Label style={labelStyle}>Status</Form.Label>
//               <Form.Select
//                 name="status"
//                 value={editFormData.status}
//                 onChange={handleEditFormChange}
//                 required
//                 style={{
//                   borderRadius: "10px",
//                   padding: "10px 14px",
//                   border: "1.5px solid #e2e8f0",
//                   fontSize: "13.5px",
//                 }}
//               >
//                 <option value="active">✅ Active</option>
//                 <option value="inactive">⛔ Inactive</option>
//               </Form.Select>
//             </Form.Group>

//             <Form.Group className="mb-3">
//               <Form.Label style={labelStyle}>Block Image</Form.Label>
//               <Form.Control
//                 type="file"
//                 name="image"
//                 accept="image/*"
//                 onChange={handleEditFormChange}
//                 ref={imageInputRef}
//                 style={{
//                   borderRadius: "10px",
//                   padding: "10px 14px",
//                   border: "1.5px solid #e2e8f0",
//                   fontSize: "13px",
//                 }}
//               />
//               {selectedBlock && selectedBlock.image && (
//                 <div style={{ marginTop: "12px" }}>
//                   <small
//                     style={{
//                       color: "#64748b",
//                       fontWeight: "600",
//                       fontSize: "11.5px",
//                     }}
//                   >
//                     Current Image:
//                   </small>
//                   <div style={{ marginTop: "6px" }}>
//                     <img
//                       src={`${imageAPIURL}/block/${selectedBlock.image}`}
//                       alt="Current Block"
//                       style={{
//                         maxWidth: "120px",
//                         maxHeight: "120px",
//                         objectFit: "cover",
//                         borderRadius: "10px",
//                         border: "1.5px solid #e2e8f0",
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//                       }}
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         e.target.src =
//                           "https://placehold.co/120x120/cccccc/333333?text=No+Image";
//                       }}
//                     />
//                   </div>
//                 </div>
//               )}
//             </Form.Group>

//             <Button
//               variant="primary"
//               type="submit"
//               className="w-100"
//               disabled={loading}
//               style={{
//                 borderRadius: "10px",
//                 fontWeight: "700",
//                 padding: "12px",
//                 background: loading
//                   ? "#cbd5e1"
//                   : "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 border: "none",
//                 boxShadow: loading
//                   ? "none"
//                   : "0 6px 18px rgba(30, 87, 153, 0.3)",
//               }}
//             >
//               {loading ? "Updating..." : "Update Block"}
//             </Button>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* ═══════════════════════════════════════════ */}
//       {/* 🎯 MESSAGE MODAL */}
//       {/* ═══════════════════════════════════════════ */}
//       {/* {showMessageModal && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           style={{
//             backgroundColor: "rgba(0,0,0,0.5)",
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             zIndex: 99999,
//           }}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div
//               className="modal-content"
//               style={{ borderRadius: "16px", border: "none" }}
//             >
//               <div
//                 style={{
//                   background:
//                     messageModalContent.type === "success"
//                       ? "linear-gradient(135deg, #059669, #047857)"
//                       : messageModalContent.type === "error"
//                       ? "linear-gradient(135deg, #dc2626, #b91c1c)"
//                       : "linear-gradient(135deg, #d97706, #b45309)",
//                   color: "#ffffff",
//                   borderRadius: "16px 16px 0 0",
//                   padding: "16px 24px",
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                 }}
//               >
//                 <h5 style={{ margin: 0, fontWeight: "800", fontSize: "16px" }}>
//                   {messageModalContent.title}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close btn-close-white"
//                   aria-label="Close"
//                   onClick={closeCustomMessageModal}
//                 ></button>
//               </div>
//               <div
//                 className="modal-body"
//                 style={{ padding: "24px", fontSize: "14px", color: "#334155" }}
//               >
//                 {messageModalContent.text}
//               </div>
//               <div
//                 className="modal-footer"
//                 style={{ borderTop: "1.5px solid #e2e8f0" }}
//               >
//                 {messageModalContent.confirmAction ? (
//                   <>
//                     <Button
//                       variant="secondary"
//                       onClick={closeCustomMessageModal}
//                       style={{ borderRadius: "10px", fontWeight: "700" }}
//                     >
//                       Cancel
//                     </Button>
//                     <Button
//                       variant={
//                         messageModalContent.type === "warning"
//                           ? "warning"
//                           : "primary"
//                       }
//                       onClick={() => {
//                         messageModalContent.confirmAction();
//                         closeCustomMessageModal();
//                       }}
//                       style={{ borderRadius: "10px", fontWeight: "700" }}
//                     >
//                       Confirm
//                     </Button>
//                   </>
//                 ) : (
//                   <Button
//                     variant={
//                       messageModalContent.type === "success"
//                         ? "success"
//                         : messageModalContent.type === "error"
//                         ? "danger"
//                         : "primary"
//                     }
//                     onClick={closeCustomMessageModal}
//                     style={{ borderRadius: "10px", fontWeight: "700" }}
//                   >
//                     OK
//                   </Button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )} */}

//       {showMessageModal && (
//   <div
//     className="modal d-block"
//     tabIndex="-1"
//     style={{
//       backgroundColor: "rgba(0,0,0,0.5)",
//       position: "fixed",
//       top: 0,
//       left: 0,
//       width: "100%",
//       height: "100%",
//       zIndex: 99999,
//     }}
//   >
//     <div className="modal-dialog modal-dialog-centered">
//       <div
//         className="modal-content"
//         style={{
//           borderRadius: "16px",
//           border: "none",
//           overflow: "hidden",
//           boxShadow: "0 20px 60px rgba(30, 87, 153, 0.25)",
//         }}
//       >
//         {/* Header — Solid #1e5799 */}
//         <div
//           style={{
//             background: "#1e5799",
//             color: "#ffffff",
//             padding: "16px 24px",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <h5 style={{ margin: 0, fontWeight: "800", fontSize: "16px" }}>
//             {messageModalContent.title}
//           </h5>
//           <button
//             type="button"
//             className="btn-close btn-close-white"
//             aria-label="Close"
//             onClick={closeCustomMessageModal}
//           ></button>
//         </div>

//         {/* Body */}
//         <div
//           className="modal-body"
//           style={{ padding: "24px", fontSize: "14px", color: "#334155" }}
//         >
//           {messageModalContent.text}
//         </div>

//         {/* Footer */}
//         <div
//           className="modal-footer"
//           style={{
//             borderTop: "1.5px solid #e2e8f0",
//             padding: "16px 24px",
//             gap: "10px",
//           }}
//         >
//           {messageModalContent.confirmAction ? (
//             <>
//               <button
//                 type="button"
//                 onClick={closeCustomMessageModal}
//                 style={{
//                   padding: "10px 22px",
//                   borderRadius: "10px",
//                   border: "1.5px solid #e2e8f0",
//                   background: "#ffffff",
//                   color: "#64748b",
//                   fontSize: "13px",
//                   fontWeight: "700",
//                   cursor: "pointer",
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 onClick={() => {
//                   messageModalContent.confirmAction();
//                   closeCustomMessageModal();
//                 }}
//                 style={{
//                   padding: "10px 22px",
//                   borderRadius: "10px",
//                   border: "none",
//                   background: "#1e5799",
//                   color: "#ffffff",
//                   fontSize: "13px",
//                   fontWeight: "700",
//                   cursor: "pointer",
//                   boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
//                 }}
//               >
//                 Confirm
//               </button>
//             </>
//           ) : (
//             <button
//               type="button"
//               onClick={closeCustomMessageModal}
//               style={{
//                 padding: "10px 22px",
//                 borderRadius: "10px",
//                 border: "none",
//                 background: "#1e5799",
//                 color: "#ffffff",
//                 fontSize: "13px",
//                 fontWeight: "700",
//                 cursor: "pointer",
//                 boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
//               }}
//             >
//               OK
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   </div>
// )}
//     </div>
//   );
// }

// // ═══════════════════════════════════════════
// // 🎨 SHARED STYLES
// // ═══════════════════════════════════════════
// const labelColor = { color: "#1e5799" };
// const textDark = { margin: "4px 0", color: "#334155" };
// const labelStyle = {
//   fontSize: "12.5px",
//   fontWeight: "700",
//   color: "#1e3a5f",
//   marginBottom: "6px",
// };

// const dropdownItem = {
//   padding: "9px 12px",
//   borderRadius: "10px",
//   fontSize: "13px",
//   fontWeight: "600",
//   gap: "10px",
//   transition: "all 0.18s ease",
//   marginBottom: "2px",
//   border: "none",
//   background: "transparent",
//   width: "100%",
//   textAlign: "left",
//   color: "#1e5799",
// };

// const iconBadge = (bg, color) => ({
//   width: "28px",
//   height: "28px",
//   borderRadius: "8px",
//   background: bg,
//   color: color,
//   display: "inline-flex",
//   alignItems: "center",
//   justifyContent: "center",
//   flexShrink: 0,
// });

// const paginationBtn = (disabled) => ({
//   width: "38px",
//   height: "38px",
//   borderRadius: "10px",
//   border: "1.5px solid #e2e8f0",
//   background: "#ffffff",
//   color: disabled ? "#cbd5e1" : "#1e5799",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   cursor: disabled ? "not-allowed" : "pointer",
//   fontWeight: "700",
// });

// export default ActiveBlockList;
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { FaPlus, FaEye, FaEdit } from "react-icons/fa";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { RiDeleteBin3Fill } from "react-icons/ri";
import { BsThreeDots } from "react-icons/bs";
import {
  MdAirplanemodeInactive,
  MdAirplanemodeActive,
} from "react-icons/md";

const API_URL = process.env.REACT_APP_API_URL;
const imageAPIURL = process.env.REACT_APP_Image_URL;

const LIMIT = 10; // ✅ Page size

function ActiveBlockList() {
  const [blocks, setBlocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0); // ✅ NEW
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEdit] = useState(false);
  const [selectedBlock, setSelectedBlock] = useState(null);
  const [selectedimagePath, setSelectedimagePath] = useState(null);
  const [editFormData, setEditFormData] = useState({
    id: "",
    name: "",
    status: "active",
    image: null,
  });
  const imageInputRef = useRef(null);

  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageModalContent, setMessageModalContent] = useState({
    title: "",
    text: "",
    type: "",
    confirmAction: null,
  });

  const getAuthToken = () => localStorage.getItem("token");

  const showCustomMessageModal = (title, text, type, confirmAction = null) => {
    setMessageModalContent({ title, text, type, confirmAction });
    setShowMessageModal(true);
  };

  const closeCustomMessageModal = () => {
    setShowMessageModal(false);
    setMessageModalContent({
      title: "",
      text: "",
      type: "",
      confirmAction: null,
    });
  };

  // ═══════════════════════════════════════════
  // 🔹 FETCH ACTIVE BLOCKS (Server-Side Pagination)
  // ═══════════════════════════════════════════
  const fetchBlocks = async (page = 1) => {
    setLoading(true);
    setError(null);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }

      const response = await fetch(
        `${API_URL}/block-list-active?page=${page}&limit=${LIMIT}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          showCustomMessageModal(
            "Authorization Error",
            "Unauthorized: Please log in again.",
            "error"
          );
        }
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch blocks.");
      }

      const data = await response.json();
      setBlocks(data.data || []);
      setSelectedimagePath(data.imagePath);

      // ✅ Server se totalPages aur total dono set karo
      const pages = Number(data.totalPages) || 1;
      const total = Number(data.total) || (data.data?.length || 0);

      setTotalPages(pages);
      setTotalItems(total);
      setCurrentPage(Number(page));
    } catch (err) {
      console.error("Fetch blocks error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlocks(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  // ═══════════════════════════════════════════
  // 🔹 VIEW BLOCK
  // ═══════════════════════════════════════════
  const handleViewBlock = async (blockId) => {
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Please log in.",
          "error"
        );
        return;
      }

      const response = await fetch(`${API_URL}/block-view`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: blockId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch block details.");
      }

      const data = await response.json();
      setSelectedBlock(data.data);
      setShowViewModal(true);
    } catch (err) {
      console.error("View block error:", err);
      showCustomMessageModal("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 EDIT BLOCK
  // ═══════════════════════════════════════════
  const handleEditBlock = async (blockId) => {
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Please log in.",
          "error"
        );
        return;
      }

      const response = await fetch(`${API_URL}/block-edit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: blockId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "Failed to fetch block for editing."
        );
      }

      const data = await response.json();
      const blockData = data.data;
      setSelectedBlock(blockData);
      setEditFormData({
        id: blockData.id,
        name: blockData.name || "",
        status: blockData.status || "active",
        image: null,
      });
      setShowEdit(true);
    } catch (err) {
      console.error("Edit block error:", err);
      showCustomMessageModal("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEditFormChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setEditFormData((prev) => ({ ...prev, image: files[0] }));
    } else {
      setEditFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 UPDATE BLOCK
  // ═══════════════════════════════════════════
  const handleUpdateBlock = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Please log in.",
          "error"
        );
        return;
      }

      const formDataToSend = new FormData();
      formDataToSend.append("project_id", editFormData.id);
      formDataToSend.append("name", editFormData.name);
      formDataToSend.append("status", editFormData.status);
      if (editFormData.image) {
        formDataToSend.append("image", editFormData.image);
      }

      const response = await fetch(`${API_URL}/block-update`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formDataToSend,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update block.");
      }

      showCustomMessageModal(
        "Success",
        "Block updated successfully!",
        "success"
      );
      setShowEdit(false);
      fetchBlocks(currentPage);
    } catch (err) {
      console.error("Update block error:", err);
      showCustomMessageModal("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 STATUS UPDATE
  // ═══════════════════════════════════════════
  const handleStatusUpdate = (blockId, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    showCustomMessageModal(
      "Confirm Status Change",
      `Do you want to change the status to ${newStatus}?`,
      "warning",
      async () => {
        setLoading(true);
        try {
          const token = getAuthToken();
          const response = await fetch(`${API_URL}/block-status-update`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ id: blockId, status: newStatus }),
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to update status.");
          }

          const result = await response.json();
          if (result.success == "1") {
            showCustomMessageModal(
              "Success",
              "Block status updated successfully!",
              "success"
            );
            fetchBlocks(currentPage);
          } else {
            showCustomMessageModal(
              "Error",
              result.message || "Something went wrong!",
              "error"
            );
          }
        } catch (err) {
          showCustomMessageModal("Error", err.message, "error");
        } finally {
          setLoading(false);
        }
      }
    );
  };

  // ═══════════════════════════════════════════
  // 🔹 DELETE BLOCK
  // ═══════════════════════════════════════════
  const handleDeleteBlock = (blockId) => {
    showCustomMessageModal(
      "Confirm Deletion",
      "Are you sure you want to delete this block? This action cannot be undone.",
      "warning",
      async () => {
        setLoading(true);
        try {
          const token = getAuthToken();
          const response = await fetch(`${API_URL}/block-delete`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ id: blockId }),
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to delete block.");
          }

          showCustomMessageModal(
            "Success",
            "Block deleted successfully!",
            "success"
          );
          fetchBlocks(currentPage);
        } catch (err) {
          showCustomMessageModal("Error", err.message, "error");
        } finally {
          setLoading(false);
        }
      }
    );
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setSelectedBlock(null);
  };

  const handleCloseEditModal = () => {
    setShowEdit(false);
    setSelectedBlock(null);
    setEditFormData({ id: "", name: "", status: "active", image: null });
    if (imageInputRef.current) imageInputRef.current.value = "";
  };

  // ═══════════════════════════════════════════
  // 🔹 LOADING
  // ═══════════════════════════════════════════
  if (loading) {
    return (
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #1e5799",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
      </div>
    );
  }

  // ═══════════════════════════════════════════
  // 🎨 PAGINATION PAGES GENERATOR
  // ═══════════════════════════════════════════
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    // Always show first page
    pages.push(1);

    // Left ellipsis
    if (showEllipsis && currentPage > 4) {
      pages.push("left-ellipsis");
    }

    // Middle pages
    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    // Right ellipsis
    if (showEllipsis && currentPage < totalPages - 3) {
      pages.push("right-ellipsis");
    }

    // Always show last page
    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  // ═══════════════════════════════════════════
  // 🎨 UI RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  flexShrink: 0,
                }}
              >
                ✅
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                    letterSpacing: "-0.3px",
                  }}
                >
                  Active Blocks
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Manage all your active blocks ({totalItems} total)
                </p>
              </div>
            </div>

            <Link
              to="/create-block"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "10px 20px",
                borderRadius: "10px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                color: "#ffffff",
                fontSize: "13px",
                fontWeight: "700",
                textDecoration: "none",
                boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
              }}
            >
              <FaPlus /> Create New Block
            </Link>
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            <div
              style={{
                overflowX: "auto",
                overflowY: "visible",
                borderRadius: "14px",
                border: "1.5px solid #e2e8f0",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "13px",
                }}
              >
                <thead>
                  <tr
                    style={{
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    }}
                  >
                    {[
                      "#",
                      "Project Name",
                      "Block Name",
                      "Image",
                      "Date",
                      "Status",
                      "Actions",
                    ].map((th, i) => (
                      <th
                        key={i}
                        style={{
                          padding: "14px 12px",
                          color: "#ffffff",
                          fontWeight: "700",
                          fontSize: "11.5px",
                          textAlign: "left",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {th}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {blocks.length > 0 ? (
                    blocks.map((block, index) => (
                      <tr
                        key={block.id}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f8fafc")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        <td
                          style={{
                            padding: "12px",
                            fontWeight: "700",
                            color: "#1e5799",
                          }}
                        >
                          {(currentPage - 1) * LIMIT + index + 1}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontWeight: "600",
                            color: "#1e3a5f",
                          }}
                        >
                          {block.project_name}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontWeight: "600",
                            color: "#334155",
                          }}
                        >
                          {block.name?.trim()}
                        </td>
                        <td style={{ padding: "12px" }}>
                          {block.image ? (
                            <img
                              src={`${imageAPIURL}/block/${block.image}`}
                              alt={`Block ${block.name}`}
                              style={{
                                width: "70px",
                                height: "50px",
                                objectFit: "cover",
                                borderRadius: "8px",
                                border: "1.5px solid #e2e8f0",
                              }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src =
                                  "https://placehold.co/100x50/cccccc/333333?text=No+Image";
                              }}
                            />
                          ) : (
                            <span
                              style={{
                                color: "#94a3b8",
                                fontSize: "12px",
                                fontWeight: "600",
                              }}
                            >
                              —
                            </span>
                          )}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            color: "#64748b",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {block.date}
                        </td>
                        <td style={{ padding: "12px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              padding: "4px 12px",
                              borderRadius: "20px",
                              fontSize: "11.5px",
                              fontWeight: "700",
                              background:
                                block.status === "active"
                                  ? "#e7f9eb"
                                  : "#feeaeb",
                              color:
                                block.status === "active"
                                  ? "#059669"
                                  : "#dc2626",
                              textTransform: "capitalize",
                            }}
                          >
                            {block.status}
                          </span>
                        </td>
                        <td style={{ padding: "12px" }}>
                          <div className="dropdown">
                            <button
                              className="btn dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              data-bs-boundary="viewport"
                              data-bs-popper-config='{"strategy":"fixed"}'
                              aria-expanded="false"
                              style={{
                                background: "#f8fafc",
                                border: "1.5px solid #e2e8f0",
                                borderRadius: "8px",
                                width: "36px",
                                height: "36px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#1e5799",
                                padding: 0,
                              }}
                            >
                              <BsThreeDots size={18} />
                            </button>
                            <ul
                              className="dropdown-menu"
                              style={{
                                zIndex: 9999,
                                borderRadius: "14px",
                                border: "none",
                                padding: "8px",
                                boxShadow:
                                  "0 12px 40px rgba(30, 87, 153, 0.18), 0 4px 12px rgba(0,0,0,0.06)",
                                minWidth: "230px",
                                marginTop: "8px",
                                background: "#ffffff",
                              }}
                            >
                              {/* View */}
                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() => handleViewBlock(block.id)}
                                  style={dropdownItem}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#e8f1fb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#e8f1fb", "#1e5799")}>
                                    <FaEye size={13} />
                                  </span>
                                  View Details
                                </button>
                              </li>

                              {/* Edit */}
                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() => handleEditBlock(block.id)}
                                  style={dropdownItem}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#e7f9eb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#e7f9eb", "#059669")}>
                                    <FaEdit size={13} />
                                  </span>
                                  Edit Block
                                </button>
                              </li>

                              <li>
                                <hr
                                  style={{
                                    margin: "6px 8px",
                                    border: "none",
                                    borderTop: "1.5px dashed #e2e8f0",
                                  }}
                                />
                              </li>

                              {/* Activate / Deactivate */}
                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() =>
                                    handleStatusUpdate(block.id, block.status)
                                  }
                                  style={{
                                    ...dropdownItem,
                                    color:
                                      block.status === "active"
                                        ? "#dc2626"
                                        : "#059669",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background =
                                      block.status === "active"
                                        ? "#feeaeb"
                                        : "#e7f9eb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span
                                    style={iconBadge(
                                      block.status === "active"
                                        ? "#feeaeb"
                                        : "#e7f9eb",
                                      block.status === "active"
                                        ? "#dc2626"
                                        : "#059669"
                                    )}
                                  >
                                    {block.status === "active" ? (
                                      <MdAirplanemodeInactive size={13} />
                                    ) : (
                                      <MdAirplanemodeActive size={13} />
                                    )}
                                  </span>
                                  {block.status === "active"
                                    ? "Deactivate"
                                    : "Activate"}
                                </button>
                              </li>

                              <li>
                                <hr
                                  style={{
                                    margin: "6px 8px",
                                    border: "none",
                                    borderTop: "1.5px dashed #e2e8f0",
                                  }}
                                />
                              </li>

                              {/* Delete */}
                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() => handleDeleteBlock(block.id)}
                                  style={{ ...dropdownItem, color: "#dc2626" }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#feeaeb";
                                    e.currentTarget.style.transform =
                                      "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#feeaeb", "#dc2626")}>
                                    <RiDeleteBin3Fill size={13} />
                                  </span>
                                  Delete Block
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="7"
                        style={{
                          padding: "50px",
                          textAlign: "center",
                          color: "#94a3b8",
                          fontWeight: "600",
                        }}
                      >
                        📭 No blocks found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* ═══════════════════════════════════════════ */}
            {/* 🎯 PAGINATION — Smart with ellipsis */}
            {/* ═══════════════════════════════════════════ */}
            {totalPages > 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "24px",
                  gap: "6px",
                  flexWrap: "wrap",
                }}
              >
                {/* Prev */}
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  ‹ Prev
                </button>

                {/* Page Numbers */}
                {getPageNumbers().map((p, i) => {
                  if (p === "left-ellipsis" || p === "right-ellipsis") {
                    return (
                      <span
                        key={`ellipsis-${i}`}
                        style={{
                          padding: "0 6px",
                          color: "#94a3b8",
                          fontWeight: "700",
                        }}
                      >
                        ...
                      </span>
                    );
                  }

                  const isActive = p === currentPage;
                  return (
                    <button
                      key={p}
                      onClick={() => handlePageChange(p)}
                      style={{
                        minWidth: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: isActive ? "none" : "1.5px solid #e2e8f0",
                        background: isActive
                          ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                          : "#ffffff",
                        color: isActive ? "#ffffff" : "#334155",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                          : "none",
                        transition: "all 0.18s ease",
                      }}
                    >
                      {p}
                    </button>
                  );
                })}

                {/* Next */}
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  Next ›
                </button>
              </div>
            )}

            {/* Page Info */}
            {totalItems > 0 && (
              <p
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#94a3b8",
                  marginTop: "12px",
                  marginBottom: 0,
                  fontWeight: "500",
                }}
              >
                Page {currentPage} of {totalPages} • {totalItems} total records
              </p>
            )}
          </div>
        </div>
      </div>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 VIEW MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showViewModal}
        onHide={handleCloseViewModal}
        centered
        size="lg"
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            📋 Block Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px" }}>
          {selectedBlock && (
            <>
              {selectedBlock.image && (
                <div style={{ marginBottom: "20px" }}>
                  <img
                    src={`${imageAPIURL}/block/${selectedBlock.image}`}
                    alt={selectedBlock.name}
                    style={{
                      width: "100%",
                      maxHeight: "280px",
                      objectFit: "cover",
                      borderRadius: "12px",
                      border: "1.5px solid #e2e8f0",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "https://placehold.co/600x280/cccccc/333333?text=No+Image";
                    }}
                  />
                </div>
              )}

              <Row className="mb-3">
                <Col md={12}>
                  <strong style={labelColor}>Project Name:</strong>
                  <p style={textDark}>{selectedBlock.project_name || "N/A"}</p>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <strong style={labelColor}>Block Name:</strong>
                  <p style={textDark}>{selectedBlock.name?.trim() || "N/A"}</p>
                </Col>
                <Col md={6}>
                  <strong style={labelColor}>Status:</strong>
                  <p style={{ margin: "4px 0" }}>
                    <span
                      style={{
                        display: "inline-block",
                        padding: "5px 14px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "700",
                        background:
                          selectedBlock.status === "active"
                            ? "#e7f9eb"
                            : "#feeaeb",
                        color:
                          selectedBlock.status === "active"
                            ? "#059669"
                            : "#dc2626",
                        textTransform: "capitalize",
                      }}
                    >
                      {selectedBlock.status}
                    </span>
                  </p>
                </Col>
              </Row>

              {selectedBlock.date && (
                <Row className="mb-3">
                  <Col md={6}>
                    <strong style={labelColor}>Date:</strong>
                    <p style={textDark}>{selectedBlock.date}</p>
                  </Col>
                </Row>
              )}

              {selectedBlock.description && (
                <Row className="mb-3">
                  <Col md={12}>
                    <strong style={labelColor}>Description:</strong>
                    <div
                      style={{ margin: "4px 0", color: "#334155" }}
                      dangerouslySetInnerHTML={{
                        __html: selectedBlock.description,
                      }}
                    />
                  </Col>
                </Row>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "1.5px solid #e2e8f0" }}>
          <Button
            variant="secondary"
            onClick={handleCloseViewModal}
            style={{
              borderRadius: "10px",
              fontWeight: "700",
              padding: "8px 24px",
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 EDIT MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showEditModal}
        onHide={handleCloseEditModal}
        centered
        size="lg"
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ✏️ Edit Block
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
        >
          <Form onSubmit={handleUpdateBlock}>
            <Form.Group className="mb-3">
              <Form.Label style={labelStyle}>Block Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={editFormData.name}
                onChange={handleEditFormChange}
                required
                style={{
                  borderRadius: "10px",
                  padding: "10px 14px",
                  border: "1.5px solid #e2e8f0",
                  fontSize: "13.5px",
                }}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label style={labelStyle}>Status</Form.Label>
              <Form.Select
                name="status"
                value={editFormData.status}
                onChange={handleEditFormChange}
                required
                style={{
                  borderRadius: "10px",
                  padding: "10px 14px",
                  border: "1.5px solid #e2e8f0",
                  fontSize: "13.5px",
                }}
              >
                <option value="active">✅ Active</option>
                <option value="inactive">⛔ Inactive</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label style={labelStyle}>Block Image</Form.Label>
              <Form.Control
                type="file"
                name="image"
                accept="image/*"
                onChange={handleEditFormChange}
                ref={imageInputRef}
                style={{
                  borderRadius: "10px",
                  padding: "10px 14px",
                  border: "1.5px solid #e2e8f0",
                  fontSize: "13px",
                }}
              />
              {selectedBlock && selectedBlock.image && (
                <div style={{ marginTop: "12px" }}>
                  <small
                    style={{
                      color: "#64748b",
                      fontWeight: "600",
                      fontSize: "11.5px",
                    }}
                  >
                    Current Image:
                  </small>
                  <div style={{ marginTop: "6px" }}>
                    <img
                      src={`${imageAPIURL}/block/${selectedBlock.image}`}
                      alt="Current Block"
                      style={{
                        maxWidth: "120px",
                        maxHeight: "120px",
                        objectFit: "cover",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          "https://placehold.co/120x120/cccccc/333333?text=No+Image";
                      }}
                    />
                  </div>
                </div>
              )}
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100"
              disabled={loading}
              style={{
                borderRadius: "10px",
                fontWeight: "700",
                padding: "12px",
                background: loading
                  ? "#cbd5e1"
                  : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                border: "none",
                boxShadow: loading
                  ? "none"
                  : "0 6px 18px rgba(30, 87, 153, 0.3)",
              }}
            >
              {loading ? "Updating..." : "Update Block"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 MESSAGE MODAL — Solid #1e5799 */}
      {/* ═══════════════════════════════════════════ */}
      {showMessageModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 99999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content"
              style={{
                borderRadius: "16px",
                border: "none",
                overflow: "hidden",
                boxShadow: "0 20px 60px rgba(30, 87, 153, 0.25)",
              }}
            >
              {/* Header */}
              <div
                style={{
                  background: "#1e5799",
                  color: "#ffffff",
                  padding: "16px 24px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h5 style={{ margin: 0, fontWeight: "800", fontSize: "16px" }}>
                  {messageModalContent.title}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  aria-label="Close"
                  onClick={closeCustomMessageModal}
                ></button>
              </div>

              {/* Body */}
              <div
                className="modal-body"
                style={{ padding: "24px", fontSize: "14px", color: "#334155" }}
              >
                {messageModalContent.text}
              </div>

              {/* Footer */}
              <div
                className="modal-footer"
                style={{
                  borderTop: "1.5px solid #e2e8f0",
                  padding: "16px 24px",
                  gap: "10px",
                }}
              >
                {messageModalContent.confirmAction ? (
                  <>
                    <button
                      type="button"
                      onClick={closeCustomMessageModal}
                      style={{
                        padding: "10px 22px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color: "#64748b",
                        fontSize: "13px",
                        fontWeight: "700",
                        cursor: "pointer",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        messageModalContent.confirmAction();
                        closeCustomMessageModal();
                      }}
                      style={{
                        padding: "10px 22px",
                        borderRadius: "10px",
                        border: "none",
                        background: "#1e5799",
                        color: "#ffffff",
                        fontSize: "13px",
                        fontWeight: "700",
                        cursor: "pointer",
                        boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                      }}
                    >
                      Confirm
                    </button>
                  </>
                ) : (
                  <button
                    type="button"
                    onClick={closeCustomMessageModal}
                    style={{
                      padding: "10px 22px",
                      borderRadius: "10px",
                      border: "none",
                      background: "#1e5799",
                      color: "#ffffff",
                      fontSize: "13px",
                      fontWeight: "700",
                      cursor: "pointer",
                      boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                    }}
                  >
                    OK
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════
// 🎨 SHARED STYLES
// ═══════════════════════════════════════════
const labelColor = { color: "#1e5799" };
const textDark = { margin: "4px 0", color: "#334155" };
const labelStyle = {
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
};

const dropdownItem = {
  padding: "9px 12px",
  borderRadius: "10px",
  fontSize: "13px",
  fontWeight: "600",
  gap: "10px",
  transition: "all 0.18s ease",
  marginBottom: "2px",
  border: "none",
  background: "transparent",
  width: "100%",
  textAlign: "left",
  color: "#1e5799",
};

const iconBadge = (bg, color) => ({
  width: "28px",
  height: "28px",
  borderRadius: "8px",
  background: bg,
  color: color,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export default ActiveBlockList;